module.exports = __webpack_public_path__ + "kendoui.29409afd0f500c1d93f0.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/images/kendoui.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/images/kendoui.ttf?v=1.1
// module chunks = styles